const binding = { modules: {}, dataActions: {} };

    (binding.modules['lobas-adventureworks'] = {
        c: () => require('partner/themes/lobas-adventureworks/lobas-adventureworks.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['active-image','b2b-requests-status','business-organization-list','buybox','cart-icon','cart','checkout-section-container','content-block','header','image-list','lobas-search','navigation-menu','order-template-list','product-specification','promo-banner','quickview','ratings-histogram','reviews-list','search-result-container','search','sign-in','store-selector','text-block','write-review'],
        iNM: false,
        ns: '__local__',
        n: 'lobas-adventureworks',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'lobas-adventureworks.theme.settings.json',
        md: 'src/themes/lobas-adventureworks'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };